import {
  ColumnHeading,
  FilterControlsConfig,
  CellValues,
  TableCellStylesFn,
  Text,
} from '@lbcamden/lib-react';

import { ActivityReportFilters, OfficerActivityResult } from '~/common/types/activityReport';

import { DirectoryUserInfo } from '../../shared/DirectoryUserInfo';
import { FailedVisitsTooltip } from './FailedVisitsTooltip';
import { ActivityReportColumnId } from './types';

export const title = 'Officer activity';

export const pageSize = 12;

export const headings: ColumnHeading<ActivityReportColumnId>[] = [
  { id: 'officerName', content: 'Officer' },
  { id: 'successfulVisitCount', content: 'Successful visits' },
  { id: 'failedVisitCount', content: 'Unsuccessful visits' },
  { id: 'totalVisitCount', content: 'Total visits' },
  { id: 'openedCaseCount', content: 'Cases opened' },
  { id: 'closedCaseCount', content: 'Cases closed' },
];

export const mobileHeadings = headings.toSpliced(1, 2);

export const filterConfigs: FilterControlsConfig<ActivityReportFilters> = [
  {
    type: 'date-range',
    key: 'dateRange',
    label: 'Date range',
    debounceWaitMs: 350,
  },
  {
    type: 'text',
    key: 'officerName',
    label: 'Search by name',
    debounceWaitMs: 350,
  },
];

export const mapResultToRow = ({
  periodStart: _0,
  periodEnd: _1,
  failedVisitCountBreakdown,
  ...result
}: OfficerActivityResult): CellValues<ActivityReportColumnId> => ({
  ...result,
  officerName: <DirectoryUserInfo camdenAccountName={result.officerCamdenAccountName} />,
  failedVisitCount: (
    <FailedVisitsTooltip
      failedVisitCount={result.failedVisitCount}
      failedVisitCountBreakdown={failedVisitCountBreakdown}
    />
  ),
  totalVisitCount: <Text $weight={600}>{result.totalVisitCount}</Text>,
});

export const cellStyles: TableCellStylesFn<ActivityReportColumnId> = (columnId) => [
  { width: 80 },
  { officerName: { width: 150 } }[columnId as string],
];
